function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M88.665,0C39.775,0,0,39.774,0,88.664c0,48.889,39.775,88.664,88.665,88.664s88.664-39.774,88.664-88.664 C177.329,39.774,137.554,0,88.665,0z M113.018,109.303l-0.436,0.298v28.825l-2.437,1.035c-6.79,2.884-14.017,4.346-21.481,4.346 c-7.47,0-14.699-1.46-21.483-4.34l-2.437-1.035v-28.831l-0.436-0.298c-11.779-8.066-18.812-21.389-18.812-35.638 c0-23.802,19.365-43.167,43.167-43.167c23.802,0,43.166,19.365,43.166,43.167C131.831,87.916,124.798,101.238,113.018,109.303z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.744,130.148c7.677,2.202,16.151,2.206,23.838-0.003v-26.872l5.657-3.872c8.51-5.826,13.591-15.447,13.591-25.737 c0-17.186-13.981-31.167-31.166-31.167c-17.186,0-31.167,13.981-31.167,31.167c0,10.288,5.082,19.909,13.593,25.738l5.654,3.874 V130.148z"
});

var SvgAccountFilled = function SvgAccountFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "177px",
    height: "177px",
    viewBox: "0 0 177 177",
    enableBackground: "new 0 0 177 177",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account_filled.c69b18bf.svg";
export { ForwardRef as ReactComponent };